import { render } from "./NotAllowedError.vue?vue&type=template&id=304796cf&scoped=true"
import script from "./NotAllowedError.vue?vue&type=script&lang=js"
export * from "./NotAllowedError.vue?vue&type=script&lang=js"

import "./NotAllowedError.vue?vue&type=style&index=0&id=304796cf&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304796cf"]])

export default __exports__